<template>
  <div>
    <div class="header"></div>
    <div class="cont-box">
      <div class="left">
        <div class="left-title">
          <p>基坑列表</p>
          <div class="btn" @click="editInfo(1)">添加</div>
        </div>
        <div class="scroll">
          <div @click="activeIndex(index)" :class="(item.status!=1?'left-item huise':'left-item')+' '+(index==active?'blue':'')" v-for="(item,index) in tabList" :key="index">
          <div class="left-item-l">
            <div class="left-item-l-name nowrap">{{item.name}}</div>
            <div class="left-item-l-state">{{item.status==1?'在建':'回填'}}</div>
          </div>
          <div class="left-item-r">
            <p class="button" style="color: #8EA3CE;border:1px solid rgba(153, 153, 153, 0.8);margin-bottom: 5px" @click="editInfo(2, item)">编辑</p>
            <p class="button button-red" style="border: 1px solid #F7A7A7;color: #F7A7A7;" @click="del(index)">删除</p>
          </div>
        </div>
        </div>
      </div>
      <div class="right">
        <div class="box1">
          <div class="box1-title">
            基坑详情
          </div>
          <div class="box1-cont">
            <div class="box1-item">
              <div v-html="'基&nbsp;&nbsp; 坑&nbsp; 名&nbsp; 称：'"></div>
              <div>{{tabListData.name}}</div>
            </div>
            <div class="box1-item">
              <div v-html="'基&nbsp;&nbsp; 坑&nbsp; 状&nbsp; 态：'"></div>
              <div>{{tabListData.status==1?'在建':'回填'}}</div>
            </div>
            <div class="box1-item">
              <div v-html="'基&nbsp;&nbsp; 坑&nbsp; 深&nbsp; 度：'"></div>
              <div>{{tabListData.depth?tabListData.depth+'m':'0m'}}</div>
            </div>
            <div class="box1-item">
              <div>基坑安全等级：</div>
              <div>{{tabListData.safeLevel==1?'一级':tabListData.safeLevel==2?'二级':tabListData.safeLevel==3?'三级':''}}</div>
            </div>
            <div class="box1-item">
              <div>施工开始时间：</div>
              <div>{{tabListData.workStart}}</div>
            </div>
            <div class="box1-item">
              <div v-html="'备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：'"></div>
              <div>{{tabListData.remark}}</div>
            </div>
          </div>
        </div>
        <div class="box2">
          <div class="box2-title">
            <div class="box2-title-l">
              深基坑主机列表
            </div>
            <div class="box2-title-r">
              <div class="btn2" @click="enterList">历史数据</div>
              <div class="btn2" @click="addItem">添加</div>
            </div>
          </div>
          <div class="box2-cont">
              <el-table
                :header-cell-style="style"
                border
                :data="dataList"
                :row-key="getRowKeys"
                @expand-change="clickTable"
                :expand-row-keys="expands"
                style="width: 100%;"
                >
                <el-table-column
                  type="index"
                  label="序号"
                  width="90">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="名称"
                  width="233">
                </el-table-column>
                <el-table-column
                  prop="dtuImei"
                  label="设备号">
                </el-table-column>
                <el-table-column
                  width="223"
                  prop="online"
                  label="设备状态">
                  <template slot-scope="scope">
                    <div style="font-size: 14px" :style="scope.row.online=='离线'?'color:#EC0F0F;':'color:#10B33B;'">{{scope.row.online}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="249"
                  prop="senserType"
                  label="设备类型">
                  <template slot-scope="scope">
                    <div style="font-size: 14px">{{scope.row.senserType==104?'测斜':'水位'}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="172"
                  prop="num"
                  label="传感器数量">
                  <template slot-scope="scope">
                    <div style="font-size: 14px">{{dataList[scope.$index].num}}</div>
                  </template>
                </el-table-column>
                <el-table-column  width="65" look="查看" type="expand">
                  <template slot-scope="scope">
                    <!-- <div class="geduan"><i style="font-size:30px" class="el-icon-caret-bottom"></i></div> -->
                    <div class="title-header">
                      <div class="header-l">{{scope.row.name}}</div>
                      <div class="header-r">
                        <div class="btn" @click="addItemSon(scope.row)">添加</div>
                        <div class="btn" @click="yjzsz(scope.row)">设置</div>
                      </div>
                    </div>
                    <el-table
                      border
                      :data="sonListData"
                      style="width: 100%">
                      <el-table-column
                        type="index"
                        label="序号"
                        width="119">
                      </el-table-column>
                      <el-table-column
                        prop="name"
                        label="名称"
                        width="233">
                      </el-table-column>
                      <el-table-column
                        width="238"
                        prop="tsSersorImei"
                        label="设备号">
                      </el-table-column>
                      <el-table-column
                        width="170"
                        prop="state"
                        label="设备状态">
                        <template slot-scope="scope">
                          <div style="font-size: 14px" :style="scope.row.state=='离线'?'color:#EC0F0F;':'color:#10B33B;'">{{scope.row.state}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="170"
                        prop="tsSersorType"
                        label="设备类型">
                        <template slot-scope="scope">
                          <div style="font-size: 14px">
                            {{scope.row.tsSersorType==104?'测斜':'水位'}}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="nowValue"
                        label="实时数值">
                        <template slot-scope="scope">
                          <div>
                            {{scope.row.nowValue?scope.row.nowValue:0}}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="warning"
                        label="预警数值">
                        <template slot-scope="scope">
                          <div>
                            {{scope.row.warning?scope.row.warning:0}}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="操作"
                        >
                        <template slot-scope="scope">
                          <div class="btns">
                            <div class="btn3" @click="upData3(scope.row)">编辑</div>
                            <div class="btn4" @click="del3(scope.row)">删除</div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="100">
                  <template slot-scope="scope">
                    <div class="btns">
<!--                       <div class="btn3">展开</div>-->
                      <div class="btn4" @click="del2(scope.row)">删除</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </div>
        <div class="box3">
          <div class="box3-item">
            <div class="b3-i-l">
              <img src="../../assets/image/download/abnormal.png" alt="">
            </div>
            <div class="b3-i-r">
              <div class="b3-i-r-t">{{numList.todayWarningCount||0}}</div>
              <div class="b3-i-r-b">今日异常</div>
            </div>
          </div>
          <div class="box3-item">
            <div class="b3-i-l">
              <img src="../../assets/image/download/jianceshi.png" alt="">
            </div>
            <div class="b3-i-r">
              <div class="b3-i-r-t">{{numList.cgPointCount||0}}</div>
              <div class="b3-i-r-b">监测点位</div>
            </div>
          </div>
          <div class="box3-item">
            <div class="b3-i-l">
              <img src="../../assets/image/download/zaixianshebei.png" alt="">
            </div>
            <div class="b3-i-r">
              <div class="b3-i-r-t">{{numList.online||0}}</div>
              <div class="b3-i-r-b">在线设备</div>
            </div>
          </div>
          <div class="box3-item">
            <div class="b3-i-l">
              <img src="../../assets/image/download/lixianshebei.png" alt="">
            </div>
            <div class="b3-i-r">
              <div class="b3-i-r-t">{{numList.offline||0}}</div>
              <div class="b3-i-r-b">离线设备</div>
            </div>
          </div>
          <div class="box3-item">
            <div class="b3-i-l">
              <img src="../../assets/image/download/jingbao.png" alt="">
            </div>
            <div class="b3-i-r">
              <div class="b3-i-r-t">{{numList.warningPointCnt||0}}</div>
              <div class="b3-i-r-b">点位报警</div>
            </div>
          </div>
        </div>
        <div class="box4" v-show="tuD1==1">
          <div class="box4-title">
            <div class="b4-xz"><i @click="indexDown" style="cursor: pointer;" class="el-icon-caret-left"></i><span style="font-size: 16px;">{{cxName}}</span><i style="cursor: pointer;" class="el-icon-caret-right" @click="indexUp"></i></div>
            <div class="b4-t-l">深基坑测斜仪监测</div>
            <div class="b4-t-r" v-if="cxListE.length!=0">{{cxSonName}}</div>
            <div class="b4-t-r" v-else>暂无传感器</div>
          </div>
          <div class="cont-l"><i @click="indexSonDown" style="cursor: pointer;font-size:34px" class="el-icon-caret-left"></i></div>
          <div class="cont-r"><i @click="indexSonUp" style="cursor: pointer;font-size:34px" class="el-icon-caret-right"></i></div>
          <div class="b4-cont" id="b4-cont" v-show="tu1==1"></div>
          <div class="b4-cont" id="b4-cont" v-show="tu1!=1" style="margin-top:12%;font-size:27px">暂无数据</div>
        </div>
        <div class="box4" v-show="tuD2==1">
          <div class="box4-title">
            <div class="b4-xz"><i @click="indexDown1" style="cursor: pointer;" class="el-icon-caret-left"></i><span style="font-size: 16px;">{{swName}}</span><i style="cursor: pointer;" class="el-icon-caret-right" @click="indexUp1"></i></div>
            <div class="b4-t-l">深基坑液位仪监测</div>
            <div class="b4-t-r" v-if="swListE.length!=0">{{swSonName}}</div>
            <div class="b4-t-r" v-else>暂无传感器</div>
          </div>
          <div class="cont-l"><i @click="indexSonDown1" style="cursor: pointer;font-size:34px" class="el-icon-caret-left"></i></div>
          <div class="cont-r"><i @click="indexSonUp1" style="cursor: pointer;font-size:34px" class="el-icon-caret-right"></i></div>
          <div class="b4-cont1" id="b4-cont1" v-show="tu2==1"></div>
          <div class="b4-cont1" id="b4-cont1" v-show="tu2!=1" style="margin-top:12%;font-size:27px">暂无数据</div>
        </div>
        <div class="box5">
          <div class="box5-title">
            <div class="b4-t-l">深基坑液位仪监测</div>
            <div class="b4-t-r">
            </div>
          </div>
          <div style="-webkit-user-select:none;
       user-select:none;" id="box5-cont" class="box5-cont" v-if="tabListData.img">
            <img style="width:100%;height:82vh;"  :src="httpCtx + tabListData.img + '?time=' + new Date().getTime()">
            <div id="cebian" class="cebian">
              <div @click="openIsShow">
                <i v-if="isShow" style="color:#fff;cursor: pointer;" class="el-icon-d-arrow-left"></i>
                <i v-else style="color:#fff;cursor: pointer;" class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <div class="cebian-item" v-for="(item,index) in testList" @mousedown="btnclick(item)" :id="item.id" :key="index">
                {{item.name}}
              </div>
            <div class="iconFt" :style="'left:'+item.left+';'+'top:'+item.top" :id="'a'+item.id" v-for="(item,index) in iconList">
                <div>{{item.name}}</div>
                <div></div>
                <div><i style="color:#f00" class="el-icon-error" @click="delIcon(item)"></i></div>
              </div>
          </div>
          <div class="box5-cont" v-else>
          <span  style="text-align: center;font-size: 16px;">暂无图片</span>
          </div>
        </div>
      </div>
      <!-- 弹出框 -->
      <el-dialog
        top="210px"
        :visible.sync="dialogVisible"
        width="34%"
        >
        <div class="title">{{indexA==1?'添加主机':'修改主机信息'}} <span class="el-icon-close del" @click="dialogVisible=false"></span></div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="基坑名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="基坑状态">
            <el-select v-model="form.status" placeholder="请选择活动区域">
              <el-option label="在建" value="1"></el-option>
              <el-option label="回填" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="基坑深度">
            <el-input v-model="form.depth"></el-input>
          </el-form-item>
          <el-form-item label="基坑安全等级">
            <el-select v-model="form.safeLevel" placeholder="请选择活动区域">
              <el-option label="一级" value="1"></el-option>
              <el-option label="二级" value="2"></el-option>
              <el-option label="三级" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="施工开始时间">
            <el-date-picker
              v-model="form.workStart"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="form.remark"
                      >
            </el-input>
          </el-form-item>
          <el-form-item label="上传基坑平面图">
            <el-upload
              :action="uploadUrl"
            :headers="uploadHead"
            :data="{type:254}"
            :on-success="successFile"
            :limit="1"
            :show-file-list="false"
            :on-exceed="exceedFile">
            <img style="width:200px;height:200px" v-if="fileList.length != 0" width="100%" :src="httpCtx + fileList[0].url + '?time=' + new Date().getTime()" alt="">
              <div v-else class="upload-div"><span class="el-icon-plus" style="color: #DEDEDE;font-size: 60px;"></span></div>
            </el-upload>
          </el-form-item>
          
        </el-form>
        <div  class="btn-b">
              <div class="btn" @click="dialogVisible=false">取消</div>
              <div class="btn" @click="successAdd(indexA)">确定</div>
            </div>
      </el-dialog>
      <!-- 主机 -->
      <el-dialog
        top="310px"
        :visible.sync="addShow"
        width="34%"
        >
        <div class="title">添加主机<span class="el-icon-close del" @click="addShow=false"></span></div>
        <el-form ref="form" :model="form1" label-width="80px">
          <el-form-item label="主机名称">
            <el-input v-model="form1.name"></el-input>
          </el-form-item>
          <el-form-item label="设备编号">
            <el-input v-model="form1.dtuImei"></el-input>
          </el-form-item>
          <el-form-item label="传感器类型">
            <el-select v-model="form1.senserType" placeholder="请选择活动区域">
              <el-option label="测斜" value="104"></el-option>
              <el-option label="水位" value="105"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div  class="btn-b" style="margin-top:15px;">
              <div class="btn" @click="addShow=false">取消</div>
              <div class="btn" @click="addTs">确定</div>
            </div>
      </el-dialog>
      <!-- 添加传感器 -->
      <el-dialog
        top="310px"
        :visible.sync="addItemShow"
        width="34%"
        >
        <div class="title">添加传感器 <span class="el-icon-close del2" @click="addItemShow=false"></span></div>
        <el-form ref="form" :model="form2" label-width="80px">
          <el-form-item label="主机名称">
            <el-input v-model="form2.name"></el-input>
          </el-form-item>
          <el-form-item label="设备编号">
            <el-input v-model="form2.tsSersorImei"></el-input>
          </el-form-item>
          <el-form-item label="传感器类型">
            <el-select v-model="form2.tsSersorType" disabled placeholder="请选择活动区域">
              <el-option label="测斜" value="104"></el-option>
              <el-option label="水位" value="105"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div  class="btn-b" style="margin-top:15px;">
              <div class="btn" @click="addItemShow=false">取消</div>
              <div class="btn" @click="addSonItem">确定</div>
            </div>
      </el-dialog>
       <!-- 修改传感器 -->
      <el-dialog
        top="310px"
        :visible.sync="addItemShow3"
        width="34%"
        >
        <div class="title">修改传感器 <span class="el-icon-close del2" @click="addItemShow3=false"></span></div>
        <el-form ref="form" :model="form3" label-width="80px">
          <el-form-item label="传感器名称">
            <el-input v-model="form3.name"></el-input>
          </el-form-item>
          <el-form-item label="传感器编号">
            <el-input v-model="form3.tsSersorImei"></el-input>
          </el-form-item>
          <el-form-item label="传感器类型">
            <el-select v-model="form3.tsSersorType" disabled placeholder="请选择">
              <el-option label="测斜" value="104"></el-option>
              <el-option label="水位" value="105"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div  class="btn-b" style="margin-top:15px;">
              <div class="btn" @click="addItemShow3=false">取消</div>
              <div class="btn" @click="addSonItem3">确定</div>
            </div>
      </el-dialog>
      <!-- 传感器预警值 -->
      <el-dialog
        top="310px"
        :visible.sync="addItemShow2"
        width="34%"
        >
        <div class="title">传感器预警值设置<span class="el-icon-close del2" @click="addItemShow2=false"></span></div>
        <el-form ref="form" :model="wvalue" label-width="80px">
          <el-form-item label="传感器预警值：">
            <el-input v-model="wvalue"></el-input>
          </el-form-item>
        </el-form>
        <div  class="btn-b" style="margin-top:15px;">
              <div class="btn" @click="addItemShow2=false">取消</div>
              <div class="btn" @click="addcgValue">确定</div>
            </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import base from '../../untils/base'
import myHttp from '../../untils/port'
import util from '../../untils/util'
  export default {
    data() {
      return {
        httpCtx: base.httpCtx,
        uploadUrl: base.url + '/upload/uploadPhoto',
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        fileList: [],
        indexA:0,
        rowId:'', // 当前展开行主机id
        dialogImageUrl:'',
        // 侧边列表基坑信息
        tabList: [],
        // 主机列表
        dataList:[
          // {
          //   name:'1号楼正面',
          //   sbh:'xx001',
          //   state:'在线',
          //   sblx:'深基坑液位仪',
          //   nmb:'3'
          // },
          // {
          //   name:'1号楼后面',
          //   sbh:'xx002',
          //   state:'离线',
          //   sblx:'深基坑测斜仪',
          //   nmb:'3'
          // }
        ],
        numList:{},
        style:{
          background:'#ECF0F5',
          border:'#E4E7EE',
          fontSize: '18px',
          fontWeight:'normal',
          letterSpacing:'0em',
          color: '#909399'
        },
        dialogVisible:false,
        form:{
          projectId:util.session.get('groupId'),
          status:'', // 状态 1在建  2回填
          name:'',
          // createDate:util.myTime.formatTime(new Date(),'YYYY-MM-dd HH:mm:ss'),
          workStart:'',
          createBy:util.session.get('user').id,
          remark:'',
          depth:'',
          img:'',
          safeLevel:''
        },
        imgVisible:false,
        addShow:false,
        addItemShow:false,
        addItemShow1:false,
        addItemShow2:false,
        addItemShow3:false,
        dtuId:'', //  当前深基坑id
        tabListData:{}, // 当前基坑信息
        sonListData:[],
        expands:[],
        getRowKeys (row) {
              return row.id
            },
        active:0,
        form1:{
          dtuId:'',
          groupId:util.session.get('groupId'),
          name:'',
          createBy:util.session.get('user').id,
          senserType:'',
          dtuImei:'',
          useType:'3',
          userType:'4',
        },
        // form2:{
        //   dtuId:'',
        //   name:'',
        //   createBy:util.session.get('user').id,
        //   senserType:'',
        //   dtuImei:'',
          
        // }
        form2:{
          tsDtuId:'',
          name:'',
          createBy:util.session.get('user').id,
          tsSersorType:'',
          tsSersorImei:'',
        },
        form3:{
          tsDtuId:'',
          name:'',
          createBy:util.session.get('user').id,
          updateBy:util.myTime.formatTime(new Date(),'YYYY-MM-dd HH:mm:ss'),
          tsSersorType:'',
          tsSersorImei:'',
          id:''
        },
        wvalue:'', // 预警值
        wvalueId:'',
        cxList:[], // 测斜主机id列表
        swList:[], // 水位主机id列表
        cxListE:[], // 测斜主机传感器id
        swListE:[], // 水位主机传感器id
        cxData:'',
        swData:'',
        cxIndex:0,
        swIndex:0,
        cxIndexE:0,
        swIndexE:0,
        lock:true,//锁,
        lock1:true,//锁,
        zhujiId:{}, // 点击添加传感器，当前主机信息
        cxName:'',
        swName:'',
        cxSonName:'',
        swSonName:'',
        ccd:[],
        timeE:util.myTime.getHMS(),
        timeSS:null,
        timeAA:null,
        tu1:1, // 图一状态（1显示、0隐藏）
        tu2:1, // 图二状态（1显示、0隐藏）
        tuD1:1, 
        tuD2:1,
        testList:[
          {
            name:'一号深基坑',
            left:0,
            top:0,
            id:'1111111111'
          },
          {
            name:'二号深基坑',
            left:0,
            top:0,
            id:'22222222222'
          },
          {
            name:'三号深基坑',
            left:0,
            top:0,
            id:'33333333333'
          },
          {
            name:'四号深基坑',
            left:0,
            top:0,
            id:'44444444444'
          },
        ],
        listItem:{},
        iconList:[],
        isDrag:false,
        isShow:false
      }
    },
    created(){
      this.active = this.$route.query.index||0
    },
    mounted(){
      // this.echartsInfo1()
      // this.echartsInfo2()
      this.getTsDeepPitPage() //获取侧边列表信息
      
    },
    beforeDestroy(){
       if(this.timeSS!=null){
          clearInterval(this.timeSS)
          clearInterval(this.timeAA)
        }
      // console.log('定时器停止了')
    },
    methods:{
      delIcon(item){
        console.log(item)
      },
      openIsShow(){
        this.isShow=!this.isShow
        if(this.isShow){
          document.getElementById('cebian').style.width='12%'
          this.testList.forEach((item,index)=>{
            console.log(item,'adasdd')
                document.getElementById(item.id).style.opacity='1'
              })
        }else{
          document.getElementById('cebian').style.width='0%'
          this.testList.forEach((item,index)=>{
                document.getElementById(item.id).style.opacity='0'
              })
        }
      },
      aaa(){
        this.testList.forEach((item,indexA)=>{
          let itemA = document.getElementById(item.id)
          console.log(itemA)
          if(indexA==0){
            itemA.style.top=0+'%'
            return
          }
        itemA.style.top = indexA*8+'%'
      })
      },
			// 点击元素事件
			btnclick(index) {
        console.log(index,'item')
        this.listItem = index
				// 打印ID值
				// 对多个元素绑定拖拽事件，要先点击，然后才能拖拽（先点击获取元素对象）
				var box=document.getElementById(index.id)
				var obox=document.getElementById("box5-cont");
				// 为每个元素加入拖拽事件
				var disX
				  var disY
				  var that = this
				  // 鼠标左键按下事件
				  box.onmousedown=function(ev){
				    var oEvent=ev||event
					// clientX，clientY：鼠标点击位置到浏览器可视区域x，y距离
					// offsetLeft，offsetTop:元素距离父级元素的偏移距离
				    disX=oEvent.clientX - box.offsetLeft
				    disY=oEvent.clientY - box.offsetTop
					that.isDrag = true
					// 鼠标移动事件
				    document.onmousemove=function(ev){
						// 加入该判断拖拽更流畅
						if (that.isDrag) {
              that.testList.forEach((item,index)=>{
                document.getElementById(item.id).style.display='none'
              })
              document.getElementById('cebian').style.display='none'
							var oEvent=ev||event
							  // 计算点击元素到父级元素的定位top，left距离
							  var l=oEvent.clientX-disX
							  var t=oEvent.clientY-disY
							  // 设置拖拽边界(限定在浏览器可视区域（空白区域）之内)
							  // 限定左边界
							  // if(l<0){
							  //   l=0
							  // }else if(l>document.documentElement.clientWidth-box.offsetWidth){
							  //   限定右边界
							  //   l=document.documentElement.clientWidth-box.offsetWidth
							  // }
							  // 限定上边界
							  // if(t<0){
							  //   t=0
							  // }else if(t>document.documentElement.clientHeight-box.offsetHeight){
							  //   限定下边界
							  //   t=document.documentElement.clientHeight-box.offsetHeight
							  // }
							  /** 限定拖拽范围，限定拖拽元素在指定的范围内 */
							  // 限定左边界和上边界
							   if(l<0){
								  l=0;
								}
								if(t<0){
								  t=0;
								}
								// 限定右边界的距离(当l=父元素宽-子元素宽时，刚好子元素放在父元素最右边)
							   if(l>obox.clientWidth - box.clientWidth){
								  l=obox.clientWidth - box.clientWidth
								}
								// 限定下边界的距离(当t=父元素高-子元素高时，刚好子元素放在父元素最下边)
								if(t>obox.clientHeight - box.clientHeight){
								   t = obox.clientHeight - box.clientHeight
								}
                if(that.iconList.length!=0){
                if(that.iconList[that.iconList.length-1].id==that.listItem.id){
                
                }else{
                  that.iconList.push(that.listItem)
                  that.testList.forEach((item,index)=>{
                    if(item.id==that.listItem.id){
                      that.testList.splice(index,1)
                      console.log(that.testList,'1')
                    }
                    // console.log(item.id,that.listItem.id,'1')
                  })
                  
                }
              }else{
                that.iconList.push(that.listItem)
                that.testList.forEach((item,index)=>{
                    if(item.id==that.listItem.id){
                      that.testList.splice(index,1)
                      console.log(that.testList,'2')
                    }
                    console.log(item.id,that.listItem.id,'2')
                  })
              }
                let box5Cont = document.getElementById('box5-cont')
                let SSt = t/box5Cont.clientHeight*100+'%'
                let SSl = l/box5Cont.clientWidth*100+'%'
                // let SSt = t+'px'
                // let SSl = l+'px'
							  
                that.listItem.left = SSl
                that.listItem.top = SSt
							}
						}
				    document.onmouseup=function(){
              document.getElementById('cebian').style.display='block'
              that.testList.forEach((item,index)=>{
                document.getElementById(item.id).style.display='block'
              })
              console.log(that.listItem)
              
				      document.onmousemove=null
				      document.onmouseup=null //鼠标抬起来后，onmouseup事件本身也没意义了，所以最好清理掉
              let iconI = document.getElementById('a'+that.listItem.id)
              iconI.style.left=that.listItem.left
              iconI.style.top=that.listItem.top
					  that.isDrag = false
				    }
				    return false //阻止默认行为，空的div在低版本ff下，第二次拖动手型会变异常
				  }
			},
			drag(box,obox) {
				  
		},
      enterList(){
        let list = ''
        let that = this
        if(this.cxList.length!=0){
          this.cxList.forEach((item,index)=>{
            list+=(item.id+',')
          })
        }
        if(this.swList.length!=0){
          this.swList.forEach((item,index)=>{
            list+=(item.id+',')
          })
        }
        list = list.split('')
        list.pop()
        list = list.join('')
        if(list){

        }else{
          this.$message({
            message:'该设备未绑定传感器！',
            type:'warning'
          })
          return
        }
        this.$router.push({
          path: '/historyListNew',
          query: {
            ids: list,
            type:2,
            index:that.active
          }
        })
      },
      upData3(item){
        this.addItemShow3 = true
        this.form3.tsDtuId = item.tsDtuId
        this.form3.name = item.name
        this.form3.tsSersorType = item.tsSersorType
        this.form3.tsSersorImei = item.tsSersorImei
        this.form3.id = item.id
      },
      // 上传图片成功的回调
      successFile(resp, file, fileList){
        // console.log(resp);
        // console.log(file);
        if(resp.code === 200){
          let obj = {}
          this.form.img = resp.data.saveUrls
          obj.name = file.name
          obj.url = resp.data.saveUrls
          this.fileList.push(JSON.parse(JSON.stringify(obj)))
        }else{
          this.$message.error(resp.msg)
        }
      },

      exceedFile(){
        this.$message.warning('只能上传一张照片！！')
      },
      indexSonUp(){
        let that = this
        if(that.cxIndexE<that.cxListE.length-1){
          // 切换传感器 ++
          that.cxIndexE++
          if(that.cxListE[that.cxIndexE] && that.lock1){
            that.lock1 = false
            that.cxSonName = that.cxListE[that.cxIndexE].name
            // console.log(that.cxSonName,'mingzi')
            that.selectValueBysensorId(that.cxListE[that.cxIndexE].id,104)
            that.lock1 = true
          }
        }else{
          
        }
      },
      indexSonDown(){
        let that = this
        if(this.cxIndexE==0){
        }else{
          // 切换主机id -
          this.cxIndexE--
          if(that.cxListE[that.cxIndexE] && that.lock1){
            that.lock1 = false
            that.cxSonName = that.cxListE[that.cxIndexE].name
            // console.log(that.cxSonName,'mingzi')
            that.selectValueBysensorId(that.cxListE[that.cxIndexE].id,104)
            that.lock1 = true
          }
        }
      },
      indexSonUp1(){
        let that = this
        if(that.swIndexE<that.swListE.length-1){
          // 切换传感器 ++
          that.swIndexE++
          if(that.swListE[that.swIndexE] && that.lock1){
            that.lock1 = false
            that.swSonName = that.swListE[that.swIndexE].name
            // console.log(that.swSonName,'mingzi')
            that.selectValueBysensorId(that.swListE[that.swIndexE].id,104)
            that.lock1 = true
          }
        }else{
          
        }
      },
      indexSonDown1(){
        let that = this
        if(this.swIndexE==0){
        }else{
          // 切换主机id -
          this.swIndexE--
          if(that.swListE[that.swIndexE] && that.lock1){
            that.lock1 = false
            that.swSonName = that.swListE[that.swIndexE].name
            // console.log(that.swSonName,'mingzi')
            that.selectValueBysensorId(that.swListE[that.swIndexE].id,104)
            that.lock1 = true
          }
        }
      },
      indexUp(){
        this.cxIndexE = 0
        let that = this
        // this.tu1 = 0
        if(this.cxIndex<this.cxList.length-1){
          // 切换主机id +
          this.cxIndex++
          // console.log(this.cxList[this.cxIndex],this.cxIndex)
          if(that.cxList[that.cxIndex] && that.lock){
                that.lock = false
                myHttp.selectTsDtuByDtuiId({
                  dtuId:that.cxList[that.cxIndex].id
                }).then(res=>{
                    if(res.data.code==200){
                      that.cxName = that.cxList[this.cxIndex].name
                      that.cxListE = res.data.data.data
                      if(that.cxListE.length!=0){
                        if(that.cxListE[0].id){
                        that.selectValueBysensorId(that.cxListE[0].id,104)
                      }
                      }else{
                        that.selectValueBysensorId('123',404)
                      }
                      that.lock = true
                      // console.log(that.cxListE,'传感器列表')
                    }else{
                      this.$message({
                        message:res.data.msg,
                        type:'warning'
                      })
                    }
                  })
                  // console.log('传感器列表长度',that.cxListE.length)
                }
        }else{
        }
      },
      indexDown(){
        this.cxIndexE = 0
        let that = this
        if(this.cxIndex==0){
        }else{
          // this.tu1 = 0
          // 切换主机id -
          this.cxIndex-- 
          // console.log(this.cxList[this.cxIndex],this.cxIndex)
           if(that.cxList[that.cxIndex] && that.lock){
                that.lock = false
                myHttp.selectTsDtuByDtuiId({
                  dtuId:that.cxList[that.cxIndex].id
                }).then(res=>{
                    if(res.data.code==200){
                      that.cxName = that.cxList[this.cxIndex].name
                      that.cxListE = res.data.data.data
                      that.lock = true
                      // console.log(that.cxListE,'传感器列表')
                      if(that.cxListE[0].id){
                        that.selectValueBysensorId(that.cxListE[0].id,104)
                      }else{
                        that.selectValueBysensorId('123',404)
                      }
                    }else{
                      this.$message({
                        message:res.data.msg,
                        type:'warning'
                      })
                    }
                  })
                  // console.log('传感器列表长度',that.cxListE.length)
                }
        }
      },
      indexUp1(){
        let that = this 
        if(this.swIndex<this.swList.length-1){
          // 切换主机id +
          this.swIndex++
          // console.log(this.cxList[this.cxIndex],this.cxIndex)
          if(that.swList[that.swIndex] && that.lock){
                that.lock = false
                myHttp.selectTsDtuByDtuiId({
                  dtuId:that.swList[that.swIndex].id
                }).then(res=>{
                    if(res.data.code==200){
                      that.swName = that.swList[this.swIndex].name
                      that.swListE = res.data.data.data
                      if(that.swListE.length!=0){
                        if(that.swListE[0].id){
                        that.selectValueBysensorId(that.swListE[0].id,105)
                      }
                      }else{
                        that.selectValueBysensorId('123',405)
                      }
                      that.lock = true
                      // console.log(that.swListE,'传感器列表')
                    }else{
                      this.$message({
                        message:res.data.msg,
                        type:'warning'
                      })
                    }
                  })
                  // console.log('传感器列表长度',that.swListE.length)
                }
        }else{
        }
      },
      indexDown1(){
        let that = this
        if(this.swIndex==0){
        }else{
          // 切换主机id -
          this.swIndex--
          // console.log(this.swList[this.swIndex],this.swIndex)
           if(that.swList[that.swIndex] && that.lock){
                that.lock = false
                myHttp.selectTsDtuByDtuiId({
                  dtuId:that.swList[that.swIndex].id
                }).then(res=>{
                    if(res.data.code==200){
                      that.swName = that.swList[this.swIndex].name
                      that.swListE = res.data.data.data
                      that.lock = true
                      // console.log(that.swListE,'传感器列表')
                     if(that.swListE[0].id){
                        that.selectValueBysensorId(that.swListE[0].id,105)
                      }else{
                        that.selectValueBysensorId('123',405)
                      }
                    }else{
                      this.$message({
                        message:res.data.msg,
                        type:'warning'
                      })
                    }
                  })
                  // console.log('传感器列表长度',that.swListE.length)
                }
        }
      },
      //
      addcgValue(){
        let that = this
        myHttp.setWarringBysensorId({
          id:this.wvalueId,
          warring:this.wvalue,
        }).then(res=>{
          if(res.data.code==200){
            this.$message({
              message:res.data.msg,
              type:'success'
            })
            myHttp.selectTsDtuByDtuiId({
              dtuId:that.rowId
            }).then(res=>{
              if(res.data.code==200){
                that.sonListData = res.data.data.data
              }else{
                this.$message({
                  message:res.data.msg,
                  type:'warning'
                })
              }
            })
            that.wvalue=''
            that.addItemShow2 = false
          }else{
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },
      // 预警值设置
      yjzsz(item){
        this.addItemShow2 = true
        this.wvalueId = item.id
      },
      // 删除传感器
      del3(item){
        let that = this
        this.$confirm('此操作将永久删除, 是否继续?', '提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          myHttp.deleteTsDtuSensorCGQNew({
            id:item.id,
            updateBy:util.session.get('user').id
          }).then(res=>{
            if(res.data.code==200){
              myHttp.selectTsDtuByDtuiId({
                dtuId:that.rowId
              }).then(res=>{
                if(res.data.code==200){
                  that.sonListData = res.data.data.data
                }else{
                  this.$message({
                    message:res.data.msg,
                    type:'warning'
                  })
                }
              })
              that.selectCountById()
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            }else{
              this.$message({
              type:'warning',
              message: res.data.msg
            });
            }
          })
        })
      },
      // 修改传感器
      addSonItem3(){
        let that = this
        // this.form3.warning = this.zhujiId.warring||0
        myHttp.uptTsDtuSensorNew(this.form3).then(res=>{
          if(res.data.code==200){
            this.$message({
              message:res.data.msg,
              type:'success'
            })
            myHttp.selectTsDtuByDtuiId({
              dtuId:that.rowId
            }).then(res=>{
              if(res.data.code==200){
                // that.sonListData = res.data.data.data
                that.selectTsDtuByDeep()
              }else{
                this.$message({
                  message:res.data.msg,
                  type:'warning'
                })
              }
            })
            that.selectCountById()
            that.addItemShow3 = false
          }else{
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },
      // 添加传感器
      addSonItem(){
        let that = this
        this.form2.warning = this.zhujiId.warring||0
        myHttp.addTsDtuSensorNew(this.form2).then(res=>{
          if(res.data.code==200){
            this.$message({
              message:res.data.msg,
              type:'success'
            })
            myHttp.selectTsDtuByDtuiId({
              dtuId:that.rowId
            }).then(res=>{
              if(res.data.code==200){
                that.sonListData = res.data.data.data
                that.selectTsDtuByDeep()
              }else{
                this.$message({
                  message:res.data.msg,
                  type:'warning'
                })
              }
            })
            that.selectCountById()
            that.form2.tsDtuId = ''
            that.form2.name = ''
            that.form2.tsSersorType = ''
            that.form2.tsSersorImei = ''
            that.addItemShow = false
          }else{
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },
      // 添加设备主机
      addTs(){
        let that = this
        
        this.form1.dtuId = this.dtuId
        myHttp.addTsDtuNew(this.form1).then(res =>{
          if(res.data.code==200){
            that.selectTsDtuByDeep()
            that.selectCountById()
            this.$message({
              message:res.data.msg,
              type:'success'
            })
            that.form1.dtuId = ''
            that.form1.name = ''
            that.form1.senserType = ''
            that.form1.dtuImei = ''
            that.addShow = false
          }else{
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },
      // 删除主机
      del2(item){
        let that = this
        this.$confirm('此操作将永久删除, 是否继续?', '提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          myHttp.deleteTsDtuNew({
            id:item.id,
            updateBy:util.session.get('user').id
          }).then(res=>{
            if(res.data.code==200){
              that.selectTsDtuByDeep()
              that.selectCountById()
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            }else{
              this.$message({
              type:'warning',
              message: res.data.msg
            });
            }
          })
        })
      },
      del(index){
        let that = this
        this.$confirm('此操作将永久删除, 是否继续?', '提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          myHttp.deleteTsDeepPitNew({
            id:that.dtuId
          }).then(res=>{
            if(res.data.code==200){
              that.selectTsDtuByDeep()
              that.selectCountById()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getTsDeepPitPage()
            }else{
              this.$message({
              type:'warning',
              message: res.data.msg
            });
            }
          })
        })
      },
      activeIndex(index){
        this.cxList = []
      this.swList = []
      this.cxListE = []
      this.cxListE = []
      this.cxData = ''
      this.swData = ''
      this.cxIndex=0,
      this.swIndex=0,
      this.cxIndexE=0,
      this.swIndexE=0,
        this.active = index
            this.dtuId = this.tabList[index].id
            this.tabListData = this.tabList[index]
        this.selectTsDtuByDeep()
        this.selectCountById()
      },
      successAdd(index){
        if(index==1){
            delete this.form.id
            this.createBy  = util.session.get('user').id,
            myHttp.addTsDeepPit(this.form).then(res=>{
            if(res.data.code==200){
              this.$message({
                message:res.data.msg,
                type:'success'
              })
              this.dialogVisible = false
              this.getTsDeepPitPage()
            }else{
              this.$message({
                message:res.data.msg,
                type:"warning"
              })
            }
          })
        }else{
          myHttp.updateTsDeepPitNew(this.form).then(res=>{
            if(res.data.code==200){
              this.$message({
                message:res.data.msg,
                type:'success'
              })
              this.dialogVisible = false
              this.getTsDeepPitPage()
            }else{
              this.$message({
                message:res.data.msg,
                type:"warning"
              })
            }
          })
        }
      },
      // clickTable(row, expandedRows) {
      //   myHttp.selectTsDtuByDtuiId({
      //     dtuId:row.id
      //   }).then(res=>{
      //   })
      // },
     clickTable(row, expandedRows) {
        var that = this
        if (expandedRows.length) {
          that.expands = []
          if (row) {
            that.expands.push(row.id)
          }
        } else {
          that.expands = []
        }
        that.rowId = row.id
        myHttp.selectTsDtuByDtuiId({
          dtuId:row.id
        }).then(res=>{
          if(res.data.code==200){
            that.sonListData = res.data.data.data
            that.sonListData.forEach((item,index)=>{
              if(item.updateDate){
                let date = new Date(item.updateDate)
                let dateing = util.myTime.formatTime(new Date(),'YYYY-MM-dd HH:mm:ss')
                date = date.getTime()
                // console.log(dateing)
                let time1 = item.updateDate
                let time2 = dateing
                let begin1 = time1.substr(0,10).split('-')
                let end1 = time2.substr(0,10).split('-')
                let date1 = new Date(begin1[1]+ - +begin1[2]+ - +begin1[0])
                let date2 = new Date(end1[1]+ - +end1[2]+ - +end1[0])
                let m = parseInt(Math.abs(date2-date1)/1000/60)
                let min1 = parseInt(time1.substr(11,2))*60+parseInt(time1.substr(14,2))
                let min2 = parseInt(time2.substr(11,2))*60+parseInt(time2.substr(14,2))
                let n = min2-min1
                item.state = (n<15 && n<0)?item.state = '在线':'离线'
              }else{
                item.state = '离线'
              }
            })
          }else{
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },
      handlePictureCardPreview(){},
      handleRemove(){},
      
      addItemSon(item){
        this.addItemShow = true
        this.form2.tsDtuId = item.id
        this.form2.tsSersorType = item.senserType+''
        this.zhujiId = item
      },
      addItem(){
        this.addShow = true
      },
      // 获取主机列表数据
      selectTsDtuByDeep(){
        this.cxIndex = 0
        this.cxIndexE = 0
        this.swIndex = 0
        this.swIndexE = 0
        this.lock=true
        this.lock1=true
        let that = this
        myHttp.selectTsDtuByDeepId({
          deepId:this.tabListData.id,
          useType:'3'
        }).then(res=>{
          if(res.data.code==200){
            that.dataList = []
            let data = res.data.data.data
            // console.log(res,'主机列表')
            let indexB = 0
            data.forEach((item,index)=>{
              if(item.senserType==104){
                    that.cxList.push(item)
                  }else if(item.senserType==105){
                    that.swList.push(item)
                  }
              myHttp.selectTsDtuCountByDtuiId({
                dtuId:item.id
              }).then(res=>{
                if(res.data.code==200){
                  data[index].num = res.data.data.data
                  indexB++
                  if(indexB==data.length){
                    that.dataList = data
                  }
                }
              })
            })
            if(that.cxList.length!=0){
              that.tuD1 = 1
              if(that.cxList[0].id){
                that.cxName = that.cxList[0].name
                myHttp.selectTsDtuByDtuiId({
                  dtuId:that.cxList[0].id
                }).then(res=>{
                    if(res.data.code==200){
                      that.cxListE = res.data.data.data
                      if(that.cxListE.length!=0){
                        that.cxSonName = that.cxListE[0].name
                        that.selectValueBysensorId(that.cxListE[0].id,104)
                      }else{
                        that.selectValueBysensorId('123',404)
                      }
                    }else{
                      this.$message({
                        message:res.data.msg,
                        type:'warning'
                      })
                    }
                  })
                }
            }else{
              that.tuD1 = 0
              if(that.timeSS!=null){
                clearInterval(that.timeSS)
              }
            }
                if(that.swList.length!=0){
                  that.tuD2 = 1
                  if(that.swList[0].id){
                    that.swName = that.swList[0].name
                    myHttp.selectTsDtuByDtuiId({
                      dtuId:that.swList[0].id
                    }).then(res=>{
                        if(res.data.code==200){
                          that.swListE = res.data.data.data
                          if(that.swListE.length!=0){
                            that.swSonName = that.swListE[0].name
                            that.selectValueBysensorId(that.swListE[0].id,105)
                          }else{
                            that.selectValueBysensorId('123',405)
                          }
                        }else{
                          this.$message({
                            message:res.data.msg,
                            type:'warning'
                          })
                        }
                      })
                    }
                }else{
                  that.tuD2=0
                  if(that.timeAA!=null){
                clearInterval(that.timeAA)
              }
                }
                if(that.tabListData.img){
                  that.aaa()
                  that.testList.forEach(item=>{
                    that.btnclick(item)
                  })
                }
          }else{
            // console.log(res.data.msg)
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },
      // 根据传感器ID获取当前值
      selectValueBysensorId(id,type){
        
        let that = this
        that.tu1 = 1
        let chartDom1
        let chartDom2
        let myChart1
        let myChart2
        let ec = that.$echarts
        if(type==104){
           chartDom1 = document.getElementById('b4-cont');
           myChart1 = ec.init(chartDom1);
        }else if(type==105){
           chartDom2 = document.getElementById('b4-cont1');
           myChart2 = ec.init(chartDom2);
        }
        
        let ccb = []
        let date = []
        if(type==404){
          chartDom1 = document.getElementById('b4-cont');
           myChart1 = ec.init(chartDom1);
          if(this.timeSS!=null){
            clearInterval(this.timeSS)
            ccb = []
            date = []
            myChart1.setOption({
              xAxis:{
                data:date
              },
              series:[
                {
                  data:ccb
                }
              ]
            })
          }
          that.tu1 = 0
          return
        }
        if(type==405){
          chartDom2 = document.getElementById('b4-cont1');
           myChart2 = ec.init(chartDom2);
          if(this.timeAA!=null){
            clearInterval(this.timeAA)
            ccb = []
            date = []
            myChart2.setOption({
              xAxis:{
                data:date
              },
              series:[
                {
                  data:ccb
                }
              ]
            })
          }
          that.tu2 = 0
          return
        }
        if(type==104){
          that.tu1 = 1
            if(that.timeSS!=null){
              clearInterval(that.timeSS)
            }
            that.timeSS = setInterval(()=>{
            myHttp.selectValueBysensorId({
              sensorId:id
            }).then(res =>{
              // console.log(res.data.data,'图1')
              if(res.data.code==200){
                if(type==104){
                  that.cxData = res.data.data
                }else if(type==105){
                  that.swData = res.data.data
                }
                if(type==104){
                  // console.log(that.cxData,'989866')
                  ccb.push(that.cxData)
                }else if(type==105){
                  ccb.push(that.swData)
                }
                date.push(util.myTime.getHMS())

                if(ccb.length>10){
                  ccb.shift()
                  date.shift()
                }
              }
            })
            
            myChart1.setOption({
              xAxis:{
                data:date
              },
              series:[
                {
                  data:ccb
                }
              ]
            })
            // console.log('定时器1')
          },2000)
          myChart1.setOption({
          xAxis: {
            axisLabel: {
              //y轴文字的配置
              textStyle: {
                color: 'rgba(138, 144, 163, 1)' //Y轴内容文字颜色
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#07DBFF'
              }
            },
            type: 'category',
            boundaryGap: false,
            data: []
          },
          color: ['#0070EE'],
          yAxis: {
            axisLabel: {
              //y轴文字的配置
              textStyle: {
                color: 'rgba(138, 144, 163, 1)' //Y轴内容文字颜色
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#07DBFF'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#07DBFF'
              }
            },
            type: 'value'
          },
          series: [
            {
              symbolSize: '12',

              data: [],
              type: 'line',
              smooth: true,
              areaStyle: {
                normal: {
                  color: new ec.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#0070EE' },
                    { offset: 0.7, color: '#0070EE' },
                    { offset: 1, color: '#00FFE4' }
                  ])
                }
              }
            }
          ]
        })
        }else if(type==105){
          that.tu2 = 1
          if(that.timeAA!=null){
            clearInterval(that.timeAA)
          }
            that.timeAA = setInterval(()=>{
          myHttp.selectValueBysensorId({
            sensorId:id
          }).then(res =>{
            // console.log(res.data.data,'图2')
            if(res.data.code==200){
              if(type==104){
                that.cxData = res.data.data
              }else if(type==105){
                that.swData = res.data.data
              }
              if(type==104){
                ccb.push(that.cxData)
              }else if(type==105){
                ccb.push(that.swData)
              }
              date.push(util.myTime.getHMS())
              if(ccb.length>10){
                ccb.shift()
                date.shift()
              }
            }
          })
          myChart2.setOption({
            xAxis:{
              data:date
            },
            series:[
              {
                data:ccb
              }
            ]
          })
          // console.log('定时器2')
        },2000)
        myChart2.setOption({
          xAxis: {
            axisLabel: {
              //y轴文字的配置
              textStyle: {
                color: 'rgba(138, 144, 163, 1)' //Y轴内容文字颜色
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#07DBFF'
              }
            },
            type: 'category',
            boundaryGap: false,
            data: []
          },
          color: ['#0070EE'],
          yAxis: {
            axisLabel: {
              //y轴文字的配置
              textStyle: {
                color: 'rgba(138, 144, 163, 1)' //Y轴内容文字颜色
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#07DBFF'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#07DBFF'
              }
            },
            type: 'value'
          },
          series: [
            {
              symbolSize: '12',

              data: [],
              type: 'line',
              smooth: true,
              areaStyle: {
                normal: {
                  color: new ec.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#0070EE' },
                    { offset: 0.7, color: '#0070EE' },
                    { offset: 1, color: '#00FFE4' }
                  ])
                }
              }
            }
          ]
        })
        }
      },
      // 获取统计数量
      selectCountById(){
        myHttp.selectCountById({
          projectId:util.session.get('groupId'),
          userType:'4',
          dtuId:this.dtuId
        }).then(res=>{
          if(res.data.code==200){
            this.numList = []
            this.numList = res.data.data
          }else{
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },

      //获取侧边列表信息
      getTsDeepPitPage(){
        let that = this
        myHttp.getTsDeepPitPage({
          projectId:util.session.get('groupId'),
          pageSize:'500',
          pageNum:'1',
        }).then(res=>{
          if(res.data.code==200){
            that.tabList = res.data.data.pageInfo.list
            that.dtuId = this.tabList[this.active].id
            that.tabListData = this.tabList[this.active]
            that.selectTsDtuByDeep() // 获得主机列表
            that.selectCountById()
          }else{
            this.$message({
              message:res.data.msg,
              type:'warning'
            })
          }
        })
      },
      // 添加基坑列表
      editInfo(index, data){
        this.indexA = index
        if(index===1){
          this.form.status = ''
          this.form.name = ''
          this.form.workStart = ''
          this.form.remark = ''
          this.form.depth = ''
          this.form.img = ''
          this.form.safeLevel = ''
          this.dialogVisible = true
        }else{
          // let data = {...this.tabListData}
          this.fileList = []
          this.form.status = data.status?data.status:''
          this.form.name = data.name?data.name:''
          this.form.workStart = data.workStart?data.workStart:''
          this.form.remark = data.remark?data.remark:''
          this.form.depth = data.depth?data.depth:''
          // this.form.img = data.img?data.img:''
          this.form.safeLevel = data.safeLevel?data.safeLevel:''
          this.form.id = data.id
          this.form.img = data.img?data.img:''
          if(data.img){
            let obj = {}
            obj.name = ''
            obj.url = data.img
            this.fileList.push(JSON.parse(JSON.stringify(obj)))
          }
          this.dialogVisible = true
        }
      },
    }
  }
</script>

<style scoped>
.header{
  height: 18px;
}
.cont-box{
  width: 100%;
  height: 87vh;
  padding: 0 24px 0 16px;
  display: flex;
  justify-content: space-between;
}
.left{
  width: 13.5vw;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.right{
  margin-left: 8px;
  flex: 1;
  overflow: auto;
}
.left-title{
  height: 58px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  border-bottom: 2px solid #E7E7E7;
}
.left-title>p{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}
.left-title>.btn{
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}
.left-title>.btn:hover{
  cursor: pointer;
  color: #fff;
  background: #4D6EB1;
}
.left-item{
  width: 13.17vw;
  height: 72px;
  margin-top: 2px;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px 0 12px;
}
.left-item-l-name{
  font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  font-weight: 350;
  letter-spacing: 0em;
  color: #8E8E8E;
}
.left-item-l{
  padding: 3% 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.left-item-l-state{
  font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  font-weight: 350;
  letter-spacing: 0em;
  color: #8E8E8E;
  text-align: start;
}
.huise{
  background-color: #E5E5E5;
}
.left-item:hover{
  background-color: #E4ECFC;
  cursor: pointer;
}
.box1{
  height: 200px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}

.box1-title{
  height: 58px;
  border-bottom: 2px solid #E7E7E7;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
  line-height: 58px;
  padding-left: 18px;
  text-align: start;
}
.box1-cont{
  height: 140px;
  padding: 15px 0 15px 0;
  display: flex;
  flex-wrap: wrap;
}
.box1-item{
  padding-left: 18px;
  min-width: 33.3%;
  display: flex;
  align-items: center;
}
.box1-item>div:nth-child(1){
  font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  font-weight: 350;
  letter-spacing: 0em;
  color: #666666;
}
.box1-item>div:nth-child(2){
  font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  font-weight: 350;
  letter-spacing: 0em;
  color: #333333;
}
.box2{
  margin-top: 16px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.box2>.box2-title{
  height: 58px;
  border-bottom: 2px solid #E7E7E7;
  display: flex;
  justify-content: space-between;
}
.box2-title-l{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
  line-height: 58px;
  padding-left: 18px;
  text-align: start;
}
.box2-title-r{
  margin-right: 16px;
  width: 168px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn2{
  width: 80px;
  height: 34px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
  line-height: 34px;
}
.btn2:hover{
  cursor: pointer;
  background: #4D6EB1;
  color: #fff;
}
.box2-cont{
  width: 100%;
  padding: 16px 8px 8px 8px;
}
.btn3{
  width: 50px;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #8EA3CE;
}
.btn3:hover{
  cursor: pointer;
  background-color: #8EA3CE;
  color: #fff;
}
.btn4{
  width: 50px;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid #F7A7A7;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #F7A7A7;
}
.btn4:hover{
  cursor: pointer;
  background-color: rgba(236, 15, 15, 0.8);
  color: #fff;
}
.btns{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 11px;
}
.box3{
  margin-top: 16px;
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: space-between;
}
.box3-item{
  width: 268px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  display: flex;
}
.b3-i-l{
  width: 148px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.b3-i-r{
  padding-top: 44px;
}
.b3-i-r-t{
  font-family: SourceHanSansCN-Regular;
  font-size: 40px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #000000;
}
.b3-i-r-b{
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #999999;
}
.box4{
  position: relative;
  margin-top: 16px;
  height: 450px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.box4-title{
  height: 58px;
  border-bottom: 2px solid #E7E7E7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
}
.b4-t-l{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}
.b4-t-r{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #999999;
}
.box5{
  margin-top: 16px;
  height: 712px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  overflow: hidden;
}
.box5-title{
  height: 58px;
  border-bottom: 2px solid #E7E7E7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
}
.b5-t-l{
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}

::v-deep .el-dialog__header{
  height: 0 !important;
  padding: 0 !important;
}
::v-deep .el-dialog__body{
  
  padding: 0 !important;
}
.title{
  height: 48px;
  border-radius: 6px 6px 0px 0px;
  background: #ECF0F5;
  display: flex;
  align-items: center;
  text-align: start;
  padding-left: 24px;
  font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.del{
  margin-left: 25vw;
  color: #9E9E9E;
  font-size: 25px;
}
.del:hover{
  cursor: pointer;
  opacity: 0.7;
}
.del2{
  margin-left: 498px;
  color: #9E9E9E;
  font-size: 25px;
}
.del2:hover{
  cursor: pointer;
  opacity: 0.7;
}
::v-deep .el-dialog{
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
::v-deep .el-form-item{
  display: flex;
  margin-bottom: 16px;
}
::v-deep .el-form-item:nth-child(1){

  margin-top: 16px;
}
::v-deep .el-form-item__label{
  width: 147px !important;
  margin-left: 80px;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #9E9E9E;
  }
::v-deep .el-form-item__content{
  margin-left: 31px !important;
  width: 340;
}
.btn-b{
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 40%;
  height: 40px;
}
.btn-b>.btn:nth-child(1){
  width: 55px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  background: #FFFFFF;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-family: SourceHanSansCN-Normal;
  font-size: 13px;
  font-weight: 350;
  letter-spacing: 0em;
  color: #666666;
}
.btn-b>.btn:nth-child(1):hover{
  cursor: pointer;
  opacity: 0.7;
}
.btn-b>.btn:nth-child(2){
  width: 55px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  background: #4D6EB1;
  font-family: SourceHanSansCN-Normal;
  font-size: 13px;
  font-weight: 350;
  letter-spacing: 0em;
  color: #FFFFFF;
}
.btn-b>.btn:nth-child(2):hover{
  cursor: pointer;
  opacity: 0.7;
}
.b4-cont{
  width: 73vw;
  height: 41vh;
  position: relative;
}
.b4-cont1{
  width: 73vw;
  height: 41vh;
}
.cont-l{
  height: 87%;
  position:absolute;
  z-index: 999;
  left: 0;
  bottom:0;
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cont-r{
  height: 87%;
  position:absolute;
  z-index: 999;
  right: 0;
  bottom:0;
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-input__inner{
  width: 300px !important;
  height: 32px !important;
}

::v-deep .el-textarea__inner{
  width: 300px !important;
}
.scroll{
  height: 80.7vh;
  overflow: auto;
}
.popover-item{
  width: 90px;
  height: 28px;
  border-radius: 6px;
  color: #9E9E9E;
  font-size: 16px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}
.popover-item:hover{
  background: #E4ECFC;
}
.cont-box >>>.el-table__expand-icon{
  height: 24px !important;
}
.cont-box >>>.el-table__expand-icon:after{
  /* position: absolute;
  left: 20%;
  top: 20%; */
  display: inline-block;
  content: '展开';
  cursor: pointer;
  color: #8EA3CE;
  border:1px solid rgba(153, 153, 153, 0.8);
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  font-size: 14px;
}
.cont-box >>>.el-table__expand-icon--expanded{
  transform: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cont-box >>>.el-table__expand-icon>.el-icon{
  display: none;
}
.cont-box >>>.el-table__expand-column{
  border-right: none !important;
}
.cont-box >>>.el-table__expand-column>.cell{
  height: 100% !important;
  width: 100% !important;
  padding: 0 !important;
}
.cont-box >>>.el-popover {
  min-width: 100px!important;
  padding: 12px 5px!important;
}
.cont-box >>> .cell{
  font-size: 14px;
}
.cont-box >>> .el-table td.el-table__cell div{
  font-size: 14px;
}
.button{
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  text-align: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff!important;
}
.cont-box >>> .el-table--border, .el-table--group{
  border: 1px solid #EBEEF5;
}
.button-red:hover{
  background-color: #F56C6C;
  color: #fff!important;
}
</style>
<style>

.geduan{
  height: 30px;
  padding-left: 94%;
  line-height: 30px;
}
.title-header{
  background-color: rgba(236, 240, 245, 0.6);
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
  padding: 0 18px;
}
.header-r{
  width: 172px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-r>.btn{
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-r>.btn:hover{
  cursor: pointer;
  color: #fff;
  background-color: #4D6EB1;
}
.blue{
  background-color: #E4ECFC !important;
}
.cebian{
  position: absolute;
  background-color: rgba(255,255,255,0.8);
  height: 100%;
  width:0 ;
  left: 0;
  top: 0;
  /* overflow: auto; */
  transition: width 0.3s;
}
.cebian>div{
  position: absolute;
    right: -16px;
    width: 16px;
    height: 43px;
    top: 41%;
    background: rgb(77,110,177);
    display: flex;
    align-items: center;
}
.cebian-item{
  width: 12%;
  background-color: #fff;
  font-size: 14px;
  height: 5vh;
  margin-top: 0.6vh;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  /* z-index: 300; */
  opacity: 0;
}
.iconItem{
  width: 20px;
  height: 20px;
  background-color: #f00;
  
}
.cebian-item:hover{
  cursor: pointer;
  background-color: #4D6EB1;
  color:#fff;
}
.box5-cont{
  width:100%;
  height:82vh;
  position: relative;
}
  .iconFt{
        width: 13%;
    height: 13%;
    position: absolute;
    /* border: 1px solid; */
  }
  .iconFt>div:nth-child(2){
        height: 38%;
    width: 19%;
    margin: 5% 23%;
    border-radius: 50%;
    background: rgb(98,170,252);
  }
  .iconFt>div:nth-child(3){
    position: absolute;
    right: -3%;
    top: -6%;
    cursor: pointer;
  }
  .iconFt>div:nth-child(1){
    width: 100%;
    font-size: 12px;
    background: #fff;
    height: 42px;
    line-height: 42px;
    position: relative;
    border-radius: 5px;
    /* overflow: hidden; */
    white-space:nowrap;
    text-overflow: ellipsis;
  }
  .iconFt>div:nth-child(1)::before{
    content: "";
    position: absolute;
    left: 54px;
    bottom: -7px;
    width: 0;
    height: 0;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    z-index: 400;
  }
</style>